module.exports = __webpack_public_path__ + "img/tos_b.7282e87a.svg";